import produce from 'immer';
import {State, Actions} from './interfaces';
import {
  GET_WAREHOUSES,
  GET_WAREHOUSES_SUCCESS,
  GET_WAREHOUSES_FAILED,
  GET_WAREHOUSES_INVENTORY,
  GET_WAREHOUSES_INVENTORY_SUCCESS,
  GET_WAREHOUSES_INVENTORY_FAILED,
  GET_INVENTORY_ITEMS,
  GET_INVENTORY_ITEMS_SUCCESS,
  GET_INVENTORY_ITEMS_FAILED,
  GET_WAREHOUSE_WITH_ID,
  GET_WAREHOUSE_WITH_ID_SUCCESS,
  GET_WAREHOUSE_WITH_ID_FAILED,
  GET_WAREHOUSE_CHILDREN,
  GET_WAREHOUSE_CHILDREN_SUCCESS,
  GET_WAREHOUSE_CHILDREN_FAILED,
  GET_SKUS_INVENTORY,
  GET_SKUS_INVENTORY_SUCCESS,
  GET_SKUS_INVENTORY_FAILED,
  GET_WAREHOUSES_INVENTORY_BY_ID,
  GET_WAREHOUSES_INVENTORY_BY_ID_SUCCESS,
  GET_WAREHOUSES_INVENTORY_BY_ID_FAILED,
  GET_PARCELS_ITEMS,
  GET_PARCELS_ITEMS_SUCCESS,
  GET_PARCELS_ITEMS_FAILED,
  GET_SKUS_INVENTORY_BY_ID,
  GET_SKUS_INVENTORY_BY_ID_SUCCESS,
  GET_SKUS_INVENTORY_BY_ID_FAILED,
  GET_SKUS_INVENTORY_FINALIZED_SUM,
  GET_SKUS_INVENTORY_FINALIZED_SUM_SUCCESS,
  GET_SKUS_INVENTORY_FINALIZED_SUM_FAILED,
  GET_SKUS_INVENTORY_NOT_FINALIZED_SUM,
  GET_SKUS_INVENTORY_NOT_FINALIZED_SUM_SUCCESS,
  GET_SKUS_INVENTORY_NOT_FINALIZED_SUM_FAILED,
  GET_WAREHOUSE_OPERATORS_BY_ID,
  GET_WAREHOUSE_OPERATORS_BY_ID_SUCCESS,
  GET_WAREHOUSE_OPERATORS_BY_ID_FAILED,
  GET_INVENTORY_ITEMS_WITH_SERIAL,
  GET_INVENTORY_ITEMS_WITH_SERIAL_SUCCESS,
  GET_INVENTORY_ITEMS_WITH_SERIAL_FAILED,
} from './constants';

export const initialState: State = {
  warehousesList: [],
  warehousesChildrenList: [],
  skusInventorylist: [],
  skusInventorylistCount: 0,
  inventoryItemsWithSerialLoading: false,
  inventoryItemsWithSerialList: [],
  inventoryItemsWithSerialError: '',
  skuInventory: [],
  warehouseOperators: [],
  warehouseOperatorsCount: 0,
  skuInventoryCount: 0,
  availableCount: 0,
  onWayCount: 0,
  returnedCount: 0,
  warehousesInventoryList: [],
  warehousesInventoryListCount: 0,
  warehouseInventory: [],
  warehouseInventoryCount: 0,
  warehouse: {},
  parcelsItems: [],
  inventoryItemsList: [],
  count: 0,
  loading: false,
  error: '',
};

export const WarehousesReducer = (state = initialState, action: Actions) =>
  produce(state, draft => {
    switch (action.type) {
      case GET_WAREHOUSES:
        draft.loading = true;
        break;
      case GET_WAREHOUSES_SUCCESS:
        draft.warehousesList = action.data;
        draft.count = action.count;
        draft.loading = false;
        break;
      case GET_WAREHOUSES_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_WAREHOUSE_CHILDREN:
        draft.loading = true;
        break;
      case GET_WAREHOUSE_CHILDREN_SUCCESS:
        draft.warehousesChildrenList = action.data;
        draft.loading = false;
        break;
      case GET_WAREHOUSE_CHILDREN_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_WAREHOUSES_INVENTORY:
        draft.loading = true;
        break;
      case GET_WAREHOUSES_INVENTORY_SUCCESS:
        draft.warehousesInventoryList = action.data;
        draft.warehousesInventoryListCount = action.count;
        draft.loading = false;
        break;
      case GET_WAREHOUSES_INVENTORY_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_WAREHOUSES_INVENTORY_BY_ID:
        draft.loading = true;
        break;
      case GET_WAREHOUSES_INVENTORY_BY_ID_SUCCESS:
        draft.warehouseInventory = action.data;
        draft.warehouseInventoryCount = action.count;
        draft.loading = false;
        break;
      case GET_WAREHOUSES_INVENTORY_BY_ID_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_WAREHOUSE_OPERATORS_BY_ID:
        draft.loading = true;
        break;
      case GET_WAREHOUSE_OPERATORS_BY_ID_SUCCESS:
        draft.warehouseOperators = action.data;
        draft.warehouseOperatorsCount = action.count;
        draft.loading = false;
        break;
      case GET_WAREHOUSE_OPERATORS_BY_ID_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_SKUS_INVENTORY:
        draft.loading = true;
        break;
      case GET_SKUS_INVENTORY_SUCCESS:
        draft.skusInventorylist = action.data;
        draft.skusInventorylistCount = action.count;
        draft.loading = false;
        break;
      case GET_SKUS_INVENTORY_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_SKUS_INVENTORY_FINALIZED_SUM:
        draft.loading = true;
        break;
      case GET_SKUS_INVENTORY_FINALIZED_SUM_SUCCESS:
        draft.availableCount = action.count;
        draft.loading = false;
        break;
      case GET_SKUS_INVENTORY_FINALIZED_SUM_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_SKUS_INVENTORY_NOT_FINALIZED_SUM:
        draft.loading = true;
        break;
      case GET_SKUS_INVENTORY_NOT_FINALIZED_SUM_SUCCESS:
        draft.onWayCount = action.count;
        draft.loading = false;
        break;
      case GET_SKUS_INVENTORY_NOT_FINALIZED_SUM_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_SKUS_INVENTORY_BY_ID:
        draft.loading = true;
        break;
      case GET_SKUS_INVENTORY_BY_ID_SUCCESS:
        draft.skuInventory = action.data;
        draft.skuInventoryCount = action.count;

        draft.loading = false;
        break;
      case GET_SKUS_INVENTORY_BY_ID_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_INVENTORY_ITEMS:
        draft.loading = true;
        break;
      case GET_INVENTORY_ITEMS_SUCCESS:
        draft.inventoryItemsList = action.data;
        draft.loading = false;
        break;
      case GET_INVENTORY_ITEMS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_INVENTORY_ITEMS_WITH_SERIAL:
        draft.inventoryItemsWithSerialLoading = true;
        break;
      case GET_INVENTORY_ITEMS_WITH_SERIAL_SUCCESS:
        draft.inventoryItemsWithSerialList = action.data;
        draft.inventoryItemsWithSerialLoading = false;
        break;
      case GET_INVENTORY_ITEMS_WITH_SERIAL_FAILED:
        draft.inventoryItemsWithSerialError = action.error;
        draft.inventoryItemsWithSerialLoading = false;
        break;

      case GET_WAREHOUSE_WITH_ID:
        draft.loading = true;
        break;
      case GET_WAREHOUSE_WITH_ID_SUCCESS:
        draft.warehouse = action.data;
        draft.loading = false;
        break;
      case GET_WAREHOUSE_WITH_ID_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      case GET_PARCELS_ITEMS:
        draft.loading = true;
        break;
      case GET_PARCELS_ITEMS_SUCCESS:
        draft.parcelsItems = action.data;
        draft.loading = false;
        break;
      case GET_PARCELS_ITEMS_FAILED:
        draft.error = action.error;
        draft.loading = false;
        break;

      default:
        break;
    }
  });
export default WarehousesReducer;
